<template>
  <div class="subroute-containers">
    <div v-if="computedInSequence.length > 0 || computedNonSequence.length > 0">
      <div v-if="fetchStatus">
        <div v-if="in_sequence_routes.length > 0" class="mb-8">
          <div v-for="child in computedInSequence" :key="child.id">
            <SecondaryRoutes
              :routeId="initiator_route"
              :child="child"
              :inSubRoutes="true"
              :subRouteIndex="sub_route_index"
              :routeType="'subroute'"
              :isChild="true"
              :isInitiator="isInitiator"
              :userAccess="userAccess"
              :mainDocument="mainDocument"
              :parentRouteId="parentRouteId"
              :accessFrom="accessFrom"
              :parentRouteDue="parentRouteDue"
            />
          </div>
        </div>
        <div v-if="non_sequence_routes.length > 0">
          <div v-for="child in computedNonSequence" :key="child.id">
            <SecondaryRoutes
              :routeId="initiator_route"
              :child="child"
              :inSubRoutes="true"
              :subRouteIndex="sub_route_index"
              :routeType="'subroute'"
              :isChild="true"
              :isInitiator="isInitiator"
              :userAccess="userAccess"
              :mainDocument="mainDocument"
              :parentRouteId="parentRouteId"
              :accessFrom="accessFrom"
              :parentRouteDue="parentRouteDue"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SubRouteContainer",
  props: {
    parentRouteId: String,
    isInitiator: Boolean,
    userAccess: Number,
    mainDocument: Object,
    // accessFrom: String
    parentRouteDue: String
  },
  data() {
    return {
      sub_routes_list: { data: [] },
      in_sequence_routes: [],
      non_sequence_routes: [],
      sub_route_index: null,
      route_data: [],
      initiator_route: this.$route.params.id,
      fetchStatus: false,
      accessFrom: 'secondaryroute'
    };
  },
  components: {
    SecondaryRoutes: () => import("./SecondaryRoutes.vue"),
  },
  methods: {
    ...mapActions(["fetchParentSubRoutes", "closeSubRoute"]),
  },
  computed: {
    ...mapGetters(["getSubRoutes", "openedSubRouteContainers"]),
    computedInSequence: function () {
      return this.in_sequence_routes;
    },
    computedNonSequence: function () {
      return this.non_sequence_routes;
    }
  },
  created() {
    if (this.parentRouteId) {
      this.fetchParentSubRoutes(this.parentRouteId).then(() => {
        this.fetchStatus = true;

        this.sub_routes_list = this.getSubRoutes[this.getSubRoutes.length - 1];
        this.sub_route_index = this.sub_routes_list.index;

        if(this.getSubRoutes.length - 1 != 0) this.accessFrom = 'subroute';

        this.sub_routes_list.data.forEach(element => {
          if(element.sequence_number != null) this.in_sequence_routes.push(element);
          else this.non_sequence_routes.push(element);
        });

      });
    }
  },
};
</script>

<style scoped>
.subroute-containers {
  width: 800px;
  height: 700px;
  display: inline-block;
  margin-right: 20px;
  overflow: auto;
}
</style>